import { connect } from 'react-redux';

import UpdateForm from './components/UpdateForm';

const mapStateToProps = (state) => ({
  authenticatedID: (state.auth.sub || null),
  authedUser: state.auth,
});

export default (store) => ({
  path : 'update/:id',
  component: connect(mapStateToProps)(UpdateForm),
});



// WEBPACK FOOTER //
// ./src/routes/company/routes/Jobs/routes/Update/index.js